import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import ResourceList from "../../../components/resourceList/ResourceList";
import Input from "../../../components/input/Input";
import DashboardLayout from "../../../components/layout/DashboardLayout";
import { fetchAllUsers, toggleUserAdvertisement, toggleUserAdvertisementResetState } from "../../../store/actions/admin/users";
import styles from "./UsersScreen.module.scss";
import classNames from "classnames";

const HEADER_VALUES = [
  { label: "IME I PREZIME", key: "name", sortable: true },
  { label: "EMAIL", key: "email", sortable: true },
  { label: "ULOGA", key: "role", sortable: false },
  { label: "TELEFON", key: "phone", sortable: false },
  { label: "KOMPANIJE", key: "companies", sortable: false },
  { label: "REKLAMA", key: "advertisement", sortable: false },
  { label: "AKCIJE", sortable: false },
];

const UsersScreen = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(fetchAllUsers(1, 15, ""));
  }, [dispatch]);

  const users = useSelector((state) => state.users.users);
  const toggleAdvertisementInfo = useSelector((state) => state.users.toggleAdvertisementInfo);
  const { page, perPage, total, data, attempt } = users || {};
  const history = useHistory();

  // Handle toggle advertisement success
  useEffect(() => {
    if (toggleAdvertisementInfo.success) {
      toast.info("Reklama status promenjen");
      dispatch(toggleUserAdvertisementResetState());
      // Refresh users list
      dispatch(fetchAllUsers(page || 1, perPage || 15, searchTerm));
    }
  }, [toggleAdvertisementInfo.success, dispatch, searchTerm, page, perPage]);

  const handleToggleAdvertisement = (user, event) => {
    event.stopPropagation(); // Prevent navigation to user details
    const newShowAdValue = !user.showAd;
    dispatch(toggleUserAdvertisement(user.id, newShowAdValue));
  };

  const searchUsers = _.debounce((searchTerm) => {
    dispatch(fetchAllUsers(1, perPage || 15, searchTerm));
  }, 600);

  useEffect(() => {
    searchUsers(searchTerm);
  }, [searchTerm]);

  const onLoadPage = (newPage) => {
    dispatch(fetchAllUsers(newPage, perPage || 15, searchTerm));
  };

  const onSort = (sortBy, order) => {
    // Sorting can be implemented if needed
    dispatch(fetchAllUsers(1, perPage || 15, searchTerm));
  };

  const renderUserRow = (user, index) => {
    if (!user) return null;
    if (user.role === "ADMIN" && user.firstName === "Admin") return null;

    const companiesText = user.companies && user.companies.length > 0
      ? user.companies.map((company) => company.name).join(", ")
      : "-";

    return (
      <div
        className={classNames(styles.row, index % 2 === 0 ? styles.even : styles.odd)}
        key={user.id}
        onClick={() => history.push(`/users/${user.id}`)}
      >
        <div className={styles.cell}>
          <p className={styles.userName}>{`${user.firstName} ${user.lastName}`}</p>
        </div>
        <div className={styles.cell}>
          <p>{user.email || "-"}</p>
        </div>
        <div className={styles.cell}>
          <p>{user.role || "-"}</p>
        </div>
        <div className={styles.cell}>
          <p>{user.phone || "-"}</p>
        </div>
        <div className={styles.cell}>
          <p>{companiesText}</p>
        </div>
        <div className={styles.cell}>
          <div 
            className={classNames(
              styles.adIndicator,
              user.showAd ? styles.adEnabled : styles.adDisabled,
              styles.clickable
            )}
            onClick={(event) => handleToggleAdvertisement(user, event)}
            title={`Kliknite da ${user.showAd ? 'isključite' : 'uključite'} reklamu`}
          >
            <span className={styles.adIndicatorText}>
              {user.showAd ? "Ad ON" : "Ad OFF"}
            </span>
          </div>
        </div>
        <div className={styles.cell}>
          <button
            className={styles.viewButton}
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/users/${user.id}`);
            }}
          >
            Pregled
          </button>
        </div>
      </div>
    );
  };

  return (
    <DashboardLayout>
      <div className={styles.content}>
        <div className={styles.topPart}>
          <p className={styles.title}>Korisnici</p>
          <div className={styles.flexEnd}>
            <div className={styles.inputWrapper}>
              <Input
                onChange={(value) => {
                  setSearchTerm(value);
                }}
                value={searchTerm}
                placeholder={searchTerm === "" && "Search"}
              />
            </div>
          </div>
        </div>
        <div className={styles.listWrapper}>
          <ResourceList
            resource={{
              data: data || [],
              total: total || 0,
              page: page || 1,
              perPage: perPage || 15,
              attempt: attempt || false,
            }}
            headerValues={HEADER_VALUES}
            onLoadPage={onLoadPage}
            onSort={onSort}
            rowRender={renderUserRow}
            showLoader={true}
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default UsersScreen;
